var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "new_top" },
      [_c("header2"), _vm._v(" "), _c("navigation", { ref: "navigation" })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "sy_main" }, [
      _c(
        "div",
        { staticClass: "sym_top" },
        [
          _c("div", [
            _c(
              "div",
              { staticClass: "symt_pic", attrs: { id: "main_flexslider" } },
              [
                _c(
                  "el-carousel",
                  {
                    staticStyle: { width: "331px" },
                    attrs: {
                      trigger: "click",
                      height: "279px",
                      "indicator-position": "none"
                    }
                  },
                  _vm._l(_vm.topCarousel, function(item) {
                    return _c("el-carousel-item", { key: item.id }, [
                      _c("a", { attrs: { target: "_blank", href: item.url } }, [
                        _c("img", {
                          attrs: {
                            src: item.imgUrl,
                            width: "331",
                            height: "249"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "flex-caption" }, [
                        _c(
                          "a",
                          { attrs: { target: "_blank", href: item.url } },
                          [_vm._v(_vm._s(item.title))]
                        )
                      ])
                    ])
                  }),
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "symt_news" }, [
            _c(
              "div",
              { staticClass: "symt_news_ncov" },
              [
                _c(
                  "router-link",
                  { attrs: { to: { path: "/nCoV2019Knowledge" } } },
                  [
                    _c("img", {
                      attrs: { src: require("../assets/img/kepu.jpg") }
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "symt_news_title" },
              [
                _vm._v("热点新闻"),
                _c("router-link", { attrs: { to: { path: "/hotNews" } } }, [
                  _vm._v("[更多...]")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "symt_news_main" }, [
              _c(
                "ul",
                _vm._l(_vm.rdxwList, function(item) {
                  return _c(
                    "li",
                    { key: item.id },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            target: "_blank",
                            to: { path: "/newsInfo", query: { id: item.id } },
                            title: item.newsTitle
                          }
                        },
                        [_vm._v(_vm._s(item.newsTitle))]
                      ),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$moment(item.publishTime).format("YYYY-MM-DD")
                          )
                        )
                      ])
                    ],
                    1
                  )
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("login")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sym_content" },
        [
          _c("div", { staticClass: "symc_left" }, [
            _c("div", { staticClass: "symcl_box" }, [
              _c("div", { staticClass: "symcl_box_title" }, [
                _vm._v("党风党建")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "symcl_box_main" }, [
                _c(
                  "div",
                  { staticClass: "symcl_box_main_cell" },
                  [
                    _c(
                      "el-carousel",
                      {
                        attrs: {
                          trigger: "click",
                          height: "237px",
                          width: "199px",
                          "indicator-position": "none"
                        }
                      },
                      _vm._l(_vm.leftCarousel, function(item) {
                        return _c("el-carousel-item", { key: item.id }, [
                          _c(
                            "a",
                            { attrs: { target: "_blank", href: item.url } },
                            [
                              _c("img", {
                                attrs: {
                                  src: item.imgUrl,
                                  width: "199",
                                  height: "237"
                                }
                              })
                            ]
                          )
                        ])
                      }),
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "symcl_box" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "symcl_box_main" }, [
                _c(
                  "div",
                  {
                    staticClass: "symcl_box_main_cell",
                    staticStyle: { height: "324px", overflow: "hidden" }
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "table_down",
                        attrs: { to: { path: "/downLoad" } }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../assets/img/down_execl.jpg"),
                            width: "161",
                            height: "31"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "xiazai" },
                      _vm._l(_vm.downloadList, function(item, index) {
                        return _c(
                          "li",
                          { key: item.id },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  target: "_blank",
                                  to: {
                                    path: "/newsInfo",
                                    query: { id: item.id }
                                  },
                                  title: item.newsTitle
                                }
                              },
                              [_vm._v(_vm._s(item.newsTitle))]
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _vm._m(1)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "symc_mid" }, [
            _c("div", { staticClass: "symcm" }, [
              _c(
                "div",
                { staticClass: "symcm_title" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { path: "/continuingMedicalEducation" } } },
                    [_vm._v("继续教育")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "symcm_main" }, [
                _c("div", { staticClass: "symcm_main_box" }, [
                  _c("div", { staticClass: "symcm_main_box_cover" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "symcm_tab_title" },
                    [
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.jxjy == 1 },
                          attrs: { to: { path: "/jxjytzgg" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.jxjy = 1
                            }
                          }
                        },
                        [_vm._v("通知公告")]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.jxjy == 2 },
                          attrs: { to: { path: "/jxjyzcfg" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.jxjy = 2
                            }
                          }
                        },
                        [_vm._v("政策法规")]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.jxjy == 3 },
                          attrs: { to: { path: "/jxjygzdt" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.jxjy = 3
                            }
                          }
                        },
                        [_vm._v("工作动态")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "symcm_tab_main" }, [
                    _c(
                      "ul",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.jxjy == 1,
                            expression: "jxjy==1"
                          }
                        ]
                      },
                      _vm._l(_vm.jxjytzggList, function(item, index) {
                        return _c(
                          "li",
                          { key: item.id },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  target: "_blank",
                                  to: {
                                    path: "/newsInfo",
                                    query: { id: item.id }
                                  },
                                  title: item.newsTitle
                                }
                              },
                              [_vm._v(_vm._s(item.newsTitle))]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$moment(item.publishTime)
                                    .format("YYYY-MM-DD")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.jxjy == 2,
                            expression: "jxjy==2"
                          }
                        ]
                      },
                      _vm._l(_vm.jxjyzcfgList, function(item, index) {
                        return _c(
                          "li",
                          { key: item.id },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  target: "_blank",
                                  to: {
                                    path: "/newsInfo",
                                    query: { id: item.id }
                                  },
                                  title: item.newsTitle
                                }
                              },
                              [_vm._v(_vm._s(item.newsTitle))]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$moment(item.publishTime)
                                    .format("YYYY-MM-DD")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.jxjy == 3,
                            expression: "jxjy==3"
                          }
                        ]
                      },
                      _vm._l(_vm.jxjygzdtList, function(item, index) {
                        return _c(
                          "li",
                          { key: item.id },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  target: "_blank",
                                  to: {
                                    path: "/newsInfo",
                                    query: { id: item.id }
                                  },
                                  title: item.newsTitle
                                }
                              },
                              [_vm._v(_vm._s(item.newsTitle))]
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$moment(item.publishTime)
                                    .format("YYYY-MM-DD")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "symcm" }, [
              _c(
                "div",
                { staticClass: "symcm_title" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { path: "/learningActivities" } } },
                    [_vm._v("学会活动")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "symcm_main" }, [
                _c("div", { staticClass: "symcm_main_box" }, [
                  _c("div", { staticClass: "symcm_main_box_cover" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "symcm_tab_title" },
                    [
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.xhhd == 1 },
                          attrs: { to: { path: "/xhhdtzgg" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.xhhd = 1
                            }
                          }
                        },
                        [_vm._v("通知公告")]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.xhhd == 2 },
                          attrs: { to: { path: "/xhhdxhgl" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.xhhd = 2
                            }
                          }
                        },
                        [_vm._v("学会管理")]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.xhhd == 3 },
                          attrs: { to: { path: "/xhhdyjxh" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.xhhd = 3
                            }
                          }
                        },
                        [_vm._v("一级学会")]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.xhhd == 4 },
                          attrs: { to: { path: "/xhhdejxh" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.xhhd = 4
                            }
                          }
                        },
                        [_vm._v("二级学会")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "symcm_tab_main" }, [
                    _c("ul", [
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.xhhd == 1,
                              expression: "xhhd==1"
                            }
                          ]
                        },
                        _vm._l(_vm.xhhdtzggList, function(item, index) {
                          return _c(
                            "li",
                            { key: item.id },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    target: "_blank",
                                    to: {
                                      path: "/newsInfo",
                                      query: { id: item.id }
                                    },
                                    title: item.newsTitle
                                  }
                                },
                                [_vm._v(_vm._s(item.newsTitle))]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(item.publishTime)
                                      .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.xhhd == 2,
                              expression: "xhhd==2"
                            }
                          ]
                        },
                        _vm._l(_vm.xhhdxhglList, function(item, index) {
                          return _c(
                            "li",
                            { key: item.id },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    target: "_blank",
                                    to: {
                                      path: "/newsInfo",
                                      query: { id: item.id }
                                    },
                                    title: item.newsTitle
                                  }
                                },
                                [_vm._v(_vm._s(item.newsTitle))]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(item.publishTime)
                                      .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.xhhd == 3,
                              expression: "xhhd==3"
                            }
                          ]
                        },
                        _vm._l(_vm.xhhdyjxhList, function(item, index) {
                          return _c(
                            "li",
                            { key: item.id },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    target: "_blank",
                                    to: {
                                      path: "/newsInfo",
                                      query: { id: item.id }
                                    },
                                    title: item.newsTitle
                                  }
                                },
                                [_vm._v(_vm._s(item.newsTitle))]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(item.publishTime)
                                      .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.xhhd == 4,
                              expression: "xhhd==4"
                            }
                          ]
                        },
                        _vm._l(_vm.xhhdejxhList, function(item, index) {
                          return _c(
                            "li",
                            { key: item.id },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    target: "_blank",
                                    to: {
                                      path: "/newsInfo",
                                      query: { id: item.id }
                                    },
                                    title: item.newsTitle
                                  }
                                },
                                [_vm._v(_vm._s(item.newsTitle))]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(item.publishTime)
                                      .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "symcm" }, [
              _c(
                "div",
                { staticClass: "symcm_title" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: { to: { path: "/medicalAccidentIdentification" } }
                    },
                    [_vm._v("医疗事故鉴定")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "symcm_main" }, [
                _c("div", { staticClass: "symcm_main_box" }, [
                  _c("div", { staticClass: "symcm_main_box_cover" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "symcm_tab_title" },
                    [
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.ylsgjd == 1 },
                          attrs: { to: { path: "/ylsgjdtzgg" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.ylsgjd = 1
                            }
                          }
                        },
                        [_vm._v("通知公告")]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.ylsgjd == 2 },
                          attrs: { to: { path: "/ylsgjdzcfg" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.ylsgjd = 2
                            }
                          }
                        },
                        [_vm._v("政策法规")]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.ylsgjd == 3 },
                          attrs: { to: { path: "/ylsgjdxgwj" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.ylsgjd = 3
                            }
                          }
                        },
                        [_vm._v("相关文件")]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.ylsgjd == 4 },
                          attrs: { to: { path: "/ylsgjdgzdt" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.ylsgjd = 4
                            }
                          }
                        },
                        [_vm._v("工作动态")]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.ylsgjd == 5 },
                          attrs: { to: { path: "/ylsgjdbszn" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.ylsgjd = 5
                            }
                          }
                        },
                        [_vm._v("办事指南")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "symcm_tab_main" }, [
                    _c("ul", [
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.ylsgjd == 1,
                              expression: "ylsgjd==1"
                            }
                          ]
                        },
                        _vm._l(_vm.ylsgjdtzggList, function(item, index) {
                          return _c(
                            "li",
                            { key: item.id },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    target: "_blank",
                                    to: {
                                      path: "/newsInfo",
                                      query: { id: item.id }
                                    },
                                    title: item.newsTitle
                                  }
                                },
                                [_vm._v(_vm._s(item.newsTitle))]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(item.publishTime)
                                      .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.ylsgjd == 2,
                              expression: "ylsgjd==2"
                            }
                          ]
                        },
                        _vm._l(_vm.ylsgjdzcfgList, function(item, index) {
                          return _c(
                            "li",
                            { key: item.id },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    target: "_blank",
                                    to: {
                                      path: "/newsInfo",
                                      query: { id: item.id }
                                    },
                                    title: item.newsTitle
                                  }
                                },
                                [_vm._v(_vm._s(item.newsTitle))]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(item.publishTime)
                                      .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.ylsgjd == 3,
                              expression: "ylsgjd==3"
                            }
                          ]
                        },
                        _vm._l(_vm.ylsgjdxgwjList, function(item, index) {
                          return _c(
                            "li",
                            { key: item.id },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    target: "_blank",
                                    to: {
                                      path: "/newsInfo",
                                      query: { id: item.id }
                                    },
                                    title: item.newsTitle
                                  }
                                },
                                [_vm._v(_vm._s(item.newsTitle))]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(item.publishTime)
                                      .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.ylsgjd == 4,
                              expression: "ylsgjd==4"
                            }
                          ]
                        },
                        _vm._l(_vm.ylsgjdgzdtList, function(item, index) {
                          return _c(
                            "li",
                            { key: item.id },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    target: "_blank",
                                    to: {
                                      path: "/newsInfo",
                                      query: { id: item.id }
                                    },
                                    title: item.newsTitle
                                  }
                                },
                                [_vm._v(_vm._s(item.newsTitle))]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(item.publishTime)
                                      .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.ylsgjd == 5,
                              expression: "ylsgjd==5"
                            }
                          ]
                        },
                        _vm._l(_vm.ylsgjdbsznList, function(item, index) {
                          return _c(
                            "li",
                            { key: item.id },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    target: "_blank",
                                    to: {
                                      path: "/newsInfo",
                                      query: { id: item.id }
                                    },
                                    title: item.newsTitle
                                  }
                                },
                                [_vm._v(_vm._s(item.newsTitle))]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(item.publishTime)
                                      .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "symcm" }, [
              _c(
                "div",
                { staticClass: "symcm_title" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { path: "/regularExamination" } } },
                    [_vm._v("医师定期考核")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "symcm_main" }, [
                _c("div", { staticClass: "symcm_main_box" }, [
                  _c("div", { staticClass: "symcm_main_box_cover" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "symcm_tab_title" },
                    [
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.ysdqkh == 1 },
                          attrs: { to: { path: "/ysdqkhtzgg" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.ysdqkh = 1
                            }
                          }
                        },
                        [_vm._v("通知公告")]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.ysdqkh == 2 },
                          attrs: { to: { path: "/ysdqkhzcfg" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.ysdqkh = 2
                            }
                          }
                        },
                        [_vm._v("政策法规")]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: { tab_sel: _vm.ysdqkh == 3 },
                          attrs: { to: { path: "/ysdqkhgzdt" } },
                          nativeOn: {
                            mouseenter: function($event) {
                              _vm.ysdqkh = 3
                            }
                          }
                        },
                        [_vm._v("工作动态")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "symcm_tab_main" }, [
                    _c("ul", [
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.ysdqkh == 1,
                              expression: "ysdqkh==1"
                            }
                          ]
                        },
                        _vm._l(_vm.ysdqkhtzggList, function(item, index) {
                          return _c(
                            "li",
                            { key: item.id },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    target: "_blank",
                                    to: {
                                      path: "/newsInfo",
                                      query: { id: item.id }
                                    },
                                    title: item.newsTitle
                                  }
                                },
                                [_vm._v(_vm._s(item.newsTitle))]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(item.publishTime)
                                      .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.ysdqkh == 2,
                              expression: "ysdqkh==2"
                            }
                          ]
                        },
                        _vm._l(_vm.ysdqkhzcfgList, function(item, index) {
                          return _c(
                            "li",
                            { key: item.id },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    target: "_blank",
                                    to: {
                                      path: "/newsInfo",
                                      query: { id: item.id }
                                    },
                                    title: item.newsTitle
                                  }
                                },
                                [_vm._v(_vm._s(item.newsTitle))]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(item.publishTime)
                                      .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.ysdqkh == 3,
                              expression: "ysdqkh==3"
                            }
                          ]
                        },
                        _vm._l(_vm.ysdqkhgzdtList, function(item, index) {
                          return _c(
                            "li",
                            { key: item.id },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    target: "_blank",
                                    to: {
                                      path: "/newsInfo",
                                      query: { id: item.id }
                                    },
                                    title: item.newsTitle
                                  }
                                },
                                [_vm._v(_vm._s(item.newsTitle))]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(item.publishTime)
                                      .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("latestNewsSimple")
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {})
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { width: "1002px", margin: "0 auto" } },
      [_c("footer1")],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "symcl_box_title",
        staticStyle: { "padding-left": "28px" }
      },
      [
        _c("img", {
          attrs: {
            src: require("../assets/img/down_coures_pic.png"),
            width: "20",
            height: "20"
          }
        }),
        _vm._v("下载专区")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "symcl_box" }, [
      _c(
        "div",
        {
          staticClass: "symcl_box_title",
          staticStyle: { "padding-left": "28px" }
        },
        [
          _c("img", {
            attrs: {
              src: require("../assets/img/down_execl_pic.png"),
              width: "20",
              height: "20"
            }
          }),
          _vm._v("友情链接")
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "symcl_box_main" }, [
        _c("div", { staticClass: "symcl_box_main_cell" }, [
          _c("div", { staticClass: "goodLinks" }, [
            _c(
              "select",
              {
                attrs: {
                  name: "",
                  onchange:
                    "javascript:window.open(this.options[this.selectedIndex].value);this.selectedIndex=0"
                }
              },
              [
                _c("option", { attrs: { selected: "" } }, [
                  _vm._v("国家省相关机构")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.nhc.gov.cn" } }, [
                  _vm._v("中华人民共和国国家卫生健康委员会")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.cma.org.cn/" } }, [
                  _vm._v("中华医学会")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://wjw.hubei.gov.cn/" } }, [
                  _vm._v("湖北省卫生健康委员会")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.hbma.org.cn/" } }, [
                  _vm._v("湖北省医学会")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                attrs: {
                  name: "",
                  onchange:
                    "javascript:window.open(this.options[this.selectedIndex].value);this.selectedIndex=0"
                }
              },
              [
                _c("option", [_vm._v("市政府部门")]),
                _vm._v(" "),
                _c(
                  "option",
                  { attrs: { value: "http://wjw.shiyan.gov.cn/" } },
                  [_vm._v("市卫生健康委员会")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                attrs: {
                  name: "",
                  onchange:
                    "javascript:window.open(this.options[this.selectedIndex].value);this.selectedIndex=0"
                }
              },
              [
                _c("option", [_vm._v("县市区卫健局")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "" } }, [
                  _vm._v("郧阳区卫健局")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.yxws.gov.cn" } }, [
                  _vm._v("郧西县卫健局")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://zswjj.zhushan.cn/" } }, [
                  _vm._v("竹山县卫健局")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://wsj.zhuxi.gov.cn" } }, [
                  _vm._v("竹溪县卫健局")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "" } }, [
                  _vm._v("张湾区卫健局")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "" } }, [
                  _vm._v("丹江口市卫健局")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.fxws.gov.cn/" } }, [
                  _vm._v("房县卫健局")
                ]),
                _vm._v(" "),
                _c(
                  "option",
                  {
                    attrs: {
                      value:
                        "http://site.conac.cn/www/182711756/40522286/index.html"
                    }
                  },
                  [_vm._v("茅箭区卫健局")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                attrs: {
                  name: "",
                  onchange:
                    "javascript:window.open(this.options[this.selectedIndex].value);this.selectedIndex=0"
                }
              },
              [
                _c("option", [_vm._v("医疗卫生单位")]),
                _vm._v(" "),
                _c(
                  "option",
                  { attrs: { value: "http://www.taihehospital.com" } },
                  [_vm._v("十堰市太和医院")]
                ),
                _vm._v(" "),
                _c(
                  "option",
                  { attrs: { value: "http://www.shiyanhospital.com/" } },
                  [_vm._v("十堰市人民医院")]
                ),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.syzyy.cn" } }, [
                  _vm._v("十堰市中医院")
                ]),
                _vm._v(" "),
                _c(
                  "option",
                  { attrs: { value: "http://wsjsjd.shiyan.gov.cn/" } },
                  [_vm._v("十堰市卫生计生综合监督执法局")]
                ),
                _vm._v(" "),
                _c(
                  "option",
                  { attrs: { value: "http://cdc.shiyan.gov.cn/" } },
                  [_vm._v("十堰市疾病预防控制中心")]
                ),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.sysxyyy.com/" } }, [
                  _vm._v("十堰市西苑医院")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.hbsyfy.com" } }, [
                  _vm._v("十堰市妇幼保健院")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.syxz.net.cn" } }, [
                  _vm._v("十堰市中心血站")
                ]),
                _vm._v(" "),
                _c(
                  "option",
                  { attrs: { value: "http://www.shiyanzxy.com/index.html" } },
                  [_vm._v("十堰市中西医结合医院")]
                ),
                _vm._v(" "),
                _c(
                  "option",
                  { attrs: { value: "http://www.systlyy.org.cn/" } },
                  [_vm._v("十堰市铁路医院")]
                ),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.sy120.net" } }, [
                  _vm._v("十堰市急救中心")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.dfmhp.com.cn" } }, [
                  _vm._v("国药东风总医院")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.dfmjyy.net" } }, [
                  _vm._v("国药东风茅箭医院")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.hgyy.com.cn" } }, [
                  _vm._v("国药东风花果医院")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                attrs: {
                  name: "",
                  onchange:
                    "javascript:window.open(this.options[this.selectedIndex].value);this.selectedIndex=0"
                }
              },
              [
                _c("option", [_vm._v("其他机构")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.hbcdc.cn" } }, [
                  _vm._v("湖北省疾病预防控制中心")
                ]),
                _vm._v(" "),
                _c(
                  "option",
                  { attrs: { value: "http://wjw.hubei.gov.cn/hbwsjd/" } },
                  [_vm._v("湖北省卫生健康委员会综合监督局")]
                ),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.hbwsrc.cn" } }, [
                  _vm._v("湖北卫生人才网")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "http://www.hbccl.cn" } }, [
                  _vm._v("湖北临床检验中心")
                ])
              ]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23543608", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23543608","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Index.vue
// module id = null
// module chunks = 